import styled from 'styled-components'

export const DateInputWrapper = styled.div`
  text-align: center;
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 30%;
`
